var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.062 0a2.077 2.077 0 102.063 2.077A2.07 2.07 0 002.062 0zm0 6.923A2.077 2.077 0 104.124 9a2.07 2.07 0 00-2.062-2.075zm0 6.923a2.077 2.077 0 102.063 2.079 2.07 2.07 0 00-2.063-2.079zm19.25.692H7.562a.69.69 0 00-.687.692v1.385a.69.69 0 00.688.692h13.75a.69.69 0 00.687-.692v-1.384a.69.69 0 00-.688-.693zm0-13.846H7.562a.69.69 0 00-.687.692v1.385a.69.69 0 00.688.692h13.75A.69.69 0 0022 2.769V1.385a.69.69 0 00-.688-.693zm0 6.923H7.562a.69.69 0 00-.687.692v1.385a.69.69 0 00.688.692h13.75A.69.69 0 0022 9.692V8.308a.69.69 0 00-.688-.693z"
  })));
}

export default SvgIconList;